import { createTheme } from "@fluentui/react";

export const appTheme = createTheme({
  palette: {
    themePrimary: "#12054d",
    themePrimaryLight: "#5C45C7",
    themePrimaryMainOpaque: "#12054D58",
    themeSecondaryLight: "#AB96FA",
    themeSecondaryMain: "#7A5CF0",
    themeSecondaryMainOpaque: "#7A5CF033",
    themeSecondaryDark: "#5C45C7",
    themeBackground: "#ECECEC",
    borderLight: "#84809991",
    borderDark: "#848099e8",
    buttonHover: "#8480991c",
    warningYellow: "#FFA500",
    successGreen: "#2E7D32",
    errorRed: "#B00020",
    timerRed: "#d43821",
    neutralGrey: "#716994",
    black: "#000000",
    white: "#ffffff",
    themeLighterAlt: "#d4cfea",
    themeLighter: "#b0a8d6",
    themeLight: "#5C45C7",
    themeTertiary: "#7265af",
    themeSecondary: "#7A5CF0",
    themeDarkAlt: "#423287",
    themeDark: "#2e1f74",
    themeDarker: "#1e1060",
    neutralLighterAlt: "#faf9f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#edebe9",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#a19f9d",
    neutralSecondary: "#605e5c",
    neutralSecondaryAlt: "#8a8886",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
  },
});
